function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9.75 3.25a2 2 0 012-2h9.966a2 2 0 011.325.502l6.534 5.78a2 2 0 01.675 1.498v15.72a2 2 0 01-2 2h-16.5a2 2 0 01-2-2V3.25z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.25 7.75h-3v20.5h14A.75.75 0 0119 29v1a.75.75 0 01-.75.75H3.75a2 2 0 01-2-2V7.25a2 2 0 012-2h3.5A.75.75 0 018 6v1a.75.75 0 01-.75.75z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.5 15.5a.75.75 0 01.75-.75h11.5a.75.75 0 01.75.75v.75a.75.75 0 01-.75.75h-11.5a.75.75 0 01-.75-.75v-.75z",
  fill: "url(#documents_svg__paint0_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.5 10.5a.75.75 0 01.75-.75h6.5a.75.75 0 01.75.75v.75a.75.75 0 01-.75.75h-6.5a.75.75 0 01-.75-.75v-.75z",
  fill: "url(#documents_svg__paint1_linear)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.5 20.5a.75.75 0 01.75-.75h11.5a.75.75 0 01.75.75v.75a.75.75 0 01-.75.75h-11.5a.75.75 0 01-.75-.75v-.75z",
  fill: "url(#documents_svg__paint2_linear)"
});

var _ref6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "documents_svg__paint0_linear",
  x1: 15.938,
  y1: 14.75,
  x2: 19.825,
  y2: 19.886,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#89A6BE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#68869F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "documents_svg__paint1_linear",
  x1: 15,
  y1: 9.75,
  x2: 18.954,
  y2: 12.965,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#89A6BE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#68869F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "documents_svg__paint2_linear",
  x1: 15.938,
  y1: 19.75,
  x2: 19.825,
  y2: 24.886,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#89A6BE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#68869F"
})));

var SvgDocuments = function SvgDocuments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
};

export default SvgDocuments;